/* COMPONENT - c.11.01 - Wheelchair Selection */

export default class WheelchairDetails {
  constructor() {
    this.accessoryItems = document.querySelectorAll(".js-accessory-item");
    this.accessoryPriceNodes = [
      ...document.querySelectorAll(".js-accessory-price"),
    ];
    this.deliveryItem = document.querySelector(".js-delivery-price");
    this.duration = parseInt(
      document.querySelector(".js-duration-amount").dataset.durationAmount
    );
    this.productPriceNodes = [
      ...document.querySelectorAll(".js-product-price"),
    ];
    this.summaryRadio = document.querySelectorAll(".js-summary-radio");
    this.summarySubmit = document.querySelector(".js-summary-submit");
    this.summaryForm = document.querySelector(".js-summary-form");
    this.updateTotal();
    this.updateButtonText(this.summarySubmit);
    this.handleFormSubmit(this.summaryForm, this.summarySubmit);
  }

  calculateAccessoryTotals(prop) {
    return this.accessoryPriceNodes
      .map((el, i) => {
        if (this.accessoryItems[i].hidden === false) {
          return parseFloat(el.dataset[prop]);
        }
        return 0;
      })
      .reduce((acc, curr) => acc + curr);
  }

  calculateProductTotals(prop) {
    return this.productPriceNodes
      .map((el) => parseFloat(el.dataset[prop]))
      .reduce((acc, curr) => acc + curr);
  }

  updateTotal() {
    const _self = this;
    let grandTotal = document.querySelector(".js-grand-total");
    let beforeVatVal = document.querySelector(".js-before-vat");
    let vatVal = document.querySelector(".js-vat");

    this.accessoryItems.forEach(function (item) {
      const accessoryDeleteCta = item.querySelector(".js-delete-accessory");

      accessoryDeleteCta.addEventListener("click", (e) => {
        e.preventDefault();

        item.hidden = true;
        item
          .querySelector(".js-accessory-selected")
          .setAttribute("value", false);

        _self.removeContainer();

        let productPriceBeforeVat =
          _self.calculateProductTotals("productPriceBeforeVat") *
          _self.duration;
        let productPrice =
          _self.calculateProductTotals("productPrice") * _self.duration;

        let accumulatedAccessoryPriceBeforeVat =
          _self.calculateAccessoryTotals("accessoryPriceBeforeVat") *
          _self.duration;
        let accumulatedAccessoryPrice =
          _self.calculateAccessoryTotals("accessoryPrice") * _self.duration;

        let deliveryPriceBeforeVat = parseFloat(
          _self.deliveryItem.dataset.deliveryPriceBeforeVat
        );
        let deliveryPrice = parseFloat(
          _self.deliveryItem.dataset.deliveryPrice
        );

        let newBeforeVatTotal =
          productPriceBeforeVat +
          accumulatedAccessoryPriceBeforeVat +
          deliveryPriceBeforeVat;
        let newGrandTotal =
          productPrice + accumulatedAccessoryPrice + deliveryPrice;
        let newVatValTotal = newGrandTotal - newBeforeVatTotal;

        //Generate before vat total
        beforeVatVal.innerText = newBeforeVatTotal.toFixed(2);
        beforeVatVal.setAttribute("data-before-vat", newBeforeVatTotal);

        //Generate before vat total
        vatVal.innerText = newVatValTotal.toFixed(2);
        vatVal.setAttribute("data-vat", newVatValTotal);

        //Generate grand total
        grandTotal.innerText = newGrandTotal.toFixed(2);
        grandTotal.setAttribute("data-grand-total", newGrandTotal);
      });
    });
  }

  removeContainer() {
    const accessoryList = document.querySelector(".js-accessories");
    if (
      [...accessoryList.querySelectorAll(".js-accessory-item")].filter(
        (el) => el.hidden === false
      ).length === 0
    ) {
      accessoryList.remove();
    }
  }

  updateButtonText(el) {
    this.summaryRadio.forEach((radio) => {
      radio.addEventListener("change", function () {
        if (radio.checked && radio.getAttribute("data-type") === "collect") {
          el.value = "Complete";
        } else {
          el.value = "Pay now";
        }
      });
    });
  }

  handleFormSubmit(form, submitButton) {
    form &&
      form.addEventListener("submit", () => {
        submitButton.disabled = true;
      });
  }
}
